/* joechia-style: render [S][M][L̶] under each product card price (v2 — fix option parsing) */
(function () {
  'use strict';
  var CACHE = {};
  var QUEUE = new Set();

  function getHandle(card) {
    var link = card.querySelector('.m-product-card__link, a.m-product-card__name, .m-product-card__title a, a[href*="/products/"]');
    if (!link) return null;
    var m = (link.getAttribute('href') || '').match(/\/products\/([^?#\/]+)/);
    return m ? m[1] : null;
  }

  function isSizeOption(name) {
    return /^(size|talla|größe|taille|サイズ|尺寸|크기)$/i.test(String(name || '').trim());
  }

  function renderSizes(card, product) {
    if (card.querySelector('.jc-sizes')) return;

    // product.options is array of objects [{name, values, position}] in modern .js,
    // or array of strings in old. Support both.
    var sizeIdx = -1;
    for (var i = 0; i < product.options.length; i++) {
      var opt = product.options[i];
      var name = (opt && typeof opt === 'object') ? opt.name : opt;
      if (isSizeOption(name)) { sizeIdx = i; break; }
    }
    if (sizeIdx < 0) return;

    // Collect unique sizes with availability across all variants
    var sizeMap = {};
    product.variants.forEach(function (v) {
      // v.options is array of strings; v['option' + (sizeIdx+1)] also works
      var size = (v.options && v.options[sizeIdx]) || v['option' + (sizeIdx + 1)];
      if (!size) return;
      if (sizeMap[size] === undefined) sizeMap[size] = false;
      if (v.available) sizeMap[size] = true;
    });

    var sizes = Object.keys(sizeMap);
    if (sizes.length === 0) return;

    var ul = document.createElement('div');
    ul.className = 'jc-sizes';
    sizes.forEach(function (s) {
      var span = document.createElement('span');
      span.className = 'jc-size' + (sizeMap[s] ? '' : ' jc-size--out');
      span.textContent = '[' + s + ']';
      ul.appendChild(span);
    });

    var content = card.querySelector('.m-product-card__content') || card;
    content.appendChild(ul);
  }

  function processCard(card) {
    if (card.dataset.jcSizesProcessed && card.querySelector('.jc-sizes')) return;
    var handle = getHandle(card);
    if (!handle) return;
    card.dataset.jcSizesProcessed = '1';

    if (CACHE[handle]) {
      renderSizes(card, CACHE[handle]);
      return;
    }
    if (QUEUE.has(handle)) return;
    QUEUE.add(handle);

    fetch('/products/' + handle + '.js')
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (product) {
        QUEUE.delete(handle);
        if (!product) return;
        CACHE[handle] = product;
        document.querySelectorAll('.m-product-card').forEach(function (c) {
          if (getHandle(c) === handle) renderSizes(c, product);
        });
      })
      .catch(function () { QUEUE.delete(handle); });
  }

  function scanCards() {
    document.querySelectorAll('.m-product-card').forEach(processCard);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scanCards);
  } else {
    scanCards();
  }

  var obs = new MutationObserver(function () { scanCards(); });
  obs.observe(document.body, { childList: true, subtree: true });
})();
